import React, { Component } from 'react';
import { Table, Input, } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import consts from '../consts';

const {Search} = Input

class LoginHistory extends Component {
  columns = [
    {
      title: 'Pubkey',
      dataIndex: 'pubkey',
      key: 'pubkey',
      ellipsis: true,
    },
    {
      title: 'Tác nhân',
      dataIndex: 'agent',
      key: 'agent',
      ellipsis: true,
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      key: 'ip',
      width: 200,
    },
    {
      title: 'Thời gian đăng nhập',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 200,
    },
  ];
  
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      currentPage: 1,
      totalCount: 0,
      search: false,
      userLoginHistory: [],
    };
    this.filter = {
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
      pubkey: '',
    };
  }
  
  componentDidMount() {
    this.fetchData();
  }

  
  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    this.setState({ isLoading: true });
    if (isRefresh) {
      this.filter = {
        ...this.filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      };
      this.setState({ currentPage: 1, });
    } else {
      this.filter = {
        ...this.filter,
        pos,
        count,
      };
    }
    if(this.state.search){
      this.props.userLoginHitoryAction(this.filter, this.updateTotalCount);
    }
    else{
      this.props.loginHistoryAction(this.filter, this.updateTotalCount);
    }
  };

  
  
  updateTotalCount = (totalCount) => {
    this.setState({
      totalCount,
      isLoading: false
    });
  }
 

  onSearch = (value) => {
    this.filter = {
      ...this.filter,
      pubkey: value,
    }
    if(value){
      this.setState({search: true}, () => this.fetchData())
    }
    else{
      this.setState({search: false}, () => this.fetchData())
    }
  }

  
  render() {
    const {search, userLoginHistory} = this.state
    return (
      <div className="list-user">
        <div className="input-search align-items">
            <h3>Lịch sử đăng nhập</h3>
            <Search style={{ width: "40%" }} placeholder="Nhập Pubkey" onSearch={this.onSearch} allowClear enterButton />
        </div>
        <Table dataSource={search ? this.props.userLoginHistory  : this.props.loginHistories || []} columns={this.columns}
               pagination={{
                 current: this.state.currentPage,
                 onChange: (page, pageSize) => {
                   this.fetchData((page - 1) * pageSize, pageSize);
                   this.setState({
                     currentPage: page,
                     isLoading: true
                   });
                 },
                 defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                 total: this.state.totalCount,
                 hideOnSinglePage: true,
               }}
               bordered
               loading={this.state.isLoading}
        />
      </div>
    );
  }
}

export default LoginHistory;
